module.exports = __webpack_public_path__ + "media/images/logo-fortaleza-login_branco-25306bce1bcca5eb1bcbea99bc6fb9f6.png";